import { render } from "./tilt.vue?vue&type=template&id=6e72174c&scoped=true&ts=true"
import script from "./tilt.vue?vue&type=script&lang=ts"
export * from "./tilt.vue?vue&type=script&lang=ts"

import "./tilt.vue?vue&type=style&index=0&id=6e72174c&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e72174c"]])

export default __exports__